<template>
    <div class="items-to-pull glass-theme">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-boxes"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <div>
            <div>
                <b-modal id="modal-itp-comments" scrollable size="md" hide-footer
                    :title="'COMMENTS FOR (' + item_comments_invoice_id + ')'">
                    <ItemComments
                        :viewdata="{ invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username }" />
                </b-modal>

                <div style="width: 100%;">
                    <div>
                        <b-alert variant="secondary" show class="glass-alert">
                            <div style="display: block;">
                                <!-- Date Range Picker -->
                                <div style="display: inline-block; vertical-align: top;">
                                    <div class="filter-label">SELECT DATE RANGE</div>
                                    <b-input
                                        id="dates"
                                        size="lg"
                                        variant="dark"
                                        :placeholder="query ? [query.startDate, query.endDate].join(' - ') : ''"
                                        style="display: inline-block; width: 220px; font-size: 14px; font-weight: bold;"
                                        class="responsive-input glass-input"
                                        autocomplete="off"
                                    ></b-input>
                                    <b-button size="sm" variant="dark" @click="search_dates" class="mt-1 mt-md-0 glass-btn">SEARCH</b-button>
                                </div>

                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">SELECT STATUS</div>
                                    <b-form-select size="lg"
                                        :options="filteredStates"
                                        v-model="selected_state"
                                        class="glass-select"
                                        style="width: 180px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>

                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">PICK LOCATION</div>
                                    <b-form-select size="lg"
                                        :options="filteredPickLocations"
                                        v-model="pick_location_id"
                                        class="glass-select"
                                        style="width: 250px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>

                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">DROP LOCATION</div>
                                    <b-form-select size="lg"
                                        :options="filteredDropLocations"
                                        v-model="drop_location_id"
                                        class="glass-select"
                                        style="width: 250px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>
                                <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                                    <div class="filter-label">ORDER TYPE</div>
                                    <b-form-select size="lg"
                                        :options="filteredOrderTypes"
                                        v-model="selected_order_type"
                                        class="glass-select"
                                        style="width: 200px; font-size: 17px; font-weight: bold;">
                                    </b-form-select>
                                </div>
                            </div>
                        </b-alert>
                    </div>
                </div>

                <div style="width: 100%; padding: 5px; min-height: 0px;">
                    <b-card no-body class="glass-table-card" style="min-height: 0px;">
                        <div v-if="items_being_loaded == true">
                            <loading :active="true" :can-cancel="false" :is-full-page="false">
                            </loading>
                        </div>

                        <div v-else-if="items_being_loaded == false">
                            <div v-if="items.length > 0" class="diver">
                                <table style="width: 100%; overflow-x: scroll;" class="glass-table">
                                    <thead>
                                        <tr style="font-size: 14px; text-align: center;">
                                            <td class="srr glass-table-header" @click="sortby('invoice_id')" style="width: 100px;">
                                                INVOICE #
                                            </td>

                                            <td class="srr glass-table-header" style="width:70px;" @click="sortby('product_sku')">
                                                PRODUCT SKU
                                            </td>

                                            <td class="srr glass-table-header" style="width:200px;" @click="sortby('product_name')">
                                                PRODUCT NAME
                                            </td>

                                            <td class="srr glass-table-header" @click="sortby('is_special')" style="width:70px;">
                                                PRD TYPE
                                            </td>

                                            <td class="srr glass-table-header" @click="sortby('order_type')" style="width:100px;">
                                                ORDER TYPE
                                            </td>

                                            <td class="srr glass-table-header" style="width:50px;">
                                                QTY
                                            </td>

                                            <td class="srr glass-table-header" @click="sortby('original_locsub')" style="width: 150px;">
                                                ITEM PICK FROM
                                            </td>
                                            <td class="srr glass-table-header" @click="sortby('drop_locsub')" style="width: 200px;">
                                               DROP LOCATION
                                             </td>
                                            <td class="srr glass-table-header" style="width: 200px;">
                                                DELIVERY LOC
                                            </td>
                                            <td class="srr glass-table-header" @click="sortby('pickup_truck', packet && packet.trucksdict)"
                                                style="width:70px;">
                                                PICKUP TRUCK
                                            </td>

                                            <td class="srr glass-table-header" style="width: 120px;" @click="sortby('state')">
                                                STATUS
                                            </td>

                                            <td class="hidden-print srr glass-table-header" style="width:70px;">
                                                COMMENTS
                                            </td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr style="background: white; font-size: 14px; text-align: center;"
                                            v-for="item, idx in filteredItems" v-bind:key="idx" class="glass-table-row">
                                            <td class="srrv">
                                                {{ item.invoice_id }}
                                            </td>

                                            <td class="srrv">
                                                {{ (item.product_sku || '').toUpperCase() }}
                                            </td>

                                            <td class="srrv">
                                                {{ (item.product_name || '').toUpperCase() }}
                                            </td>

                                            <td class="srrv">
                                                <div v-if="item.is_special" style="background: pink; padding: 3px;">SPECIAL
                                                </div>
                                                <div v-else>REGULAR</div>
                                            </td>

                                            <td class="srrv">
                                                <div v-if="item.order_type == 'home_delivery'">
                                                    <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HOME DELIVERY </b-alert>
                                                </div>
                                                <div v-else-if="item.order_type == 'store_pickup'">
                                                    <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">STORE PICKUP</b-alert>
                                                </div>
                                                <div v-else-if="item.order_type == 'transfer_order'">
                                                    <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANFER</b-alert>
                                                </div>
                                                <div v-else>
                                                    {{item.order_type}}
                                                </div>
                                            </td>

                                            <td class="srrv">
                                                {{ item.quantity }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.locsubsdict ? (packet.locsubsdict[item.original_locsub ? item.original_locsub : item.original_locsub] || '') : '' }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.locsubsdict ? (packet.locsubsdict[item.ship_locsub ? item.ship_locsub : item.ship_locsub] || '') : '' }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.locsubsdict ? (packet.locsubsdict[item.drop_locsub ? item.drop_locsub : item.drop_locsub] || '') : '' }}
                                            </td>

                                            <td class="srrv">
                                                {{ packet && packet.trucksdict ? (packet.trucksdict[item.pickup_truck] || '') : '' }}
                                            </td>

                                            <td class="srrv" style="width:150px;">
                                                <b-form-select size="sm"
                                                    :style="{ background: get_background(item) }"
                                                    :options="check_states(item)" v-model="item.state"
                                                    v-on:change="update_invoice_item_state(item)"
                                                    :disabled="should_disable_dropdown(item)"
                                                    v-b-tooltip.hover="get_tooltip_message(item)"
                                                    class="glass-status-select">
                                                </b-form-select>
                                            </td>

                                            <td class="ipt_tdr srrv hidden-print">
                                                <button class="glass-comment-btn" @click="show_comments(item)">CMNT</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else>
                                <b-alert show class="glass-empty-alert">NO ITEM FOUND</b-alert>
                            </div>
                        </div>

                        <div v-else>
                        </div>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import mappings from '@/utilities/mappings'
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ItemComments from '@/components/importables/ItemComments'

export default {
    name: "ItemsToPull",
    components: { Loading, ItemComments },
    data: function () {
        let out = {
            items: [],
            dates: [],
            active_date: null,
            packet: null,  // Initialize as null
            items_being_loaded: null,
            dates_being_loaded: null,
            current_date: null,
            locations: [],
            locsub: null,
            original_locsub: null,
            states: [],  // Will be initialized in created()
            states_dict: mappings.states_dict,
            item_comments_invoice_id: null,
            item_comments_itemid: null,
            colors_dict: {},
            allowed_truck: null,
            allowed_locsub: null,
            locsubs: [],
            original_locsubs: [],
            
            // Replace year/month/date with query object
            query: {
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD')
            },
            
            selected_order_type: null,
            pick_location_id: null,
            drop_location_id: null,
            selected_state: null,
            
            // Loading animation properties
            apiLoading: false,
            loadingMessage: 'Loading Items',
            loadingProgress: 0,
            currentTipIndex: 0,
            loadingInterval: null,
            tipInterval: null,
            msgInterval: null,
            apiCallStack: 0,
            tips: [
                "📦 Fetching items to pull...",
                "🚚 Loading delivery schedules...",
                "📍 Syncing location data...",
                "📊 Processing inventory...",
                "🔄 Updating pull lists...",
                "✨ Organizing items...",
                "📈 Preparing data..."
            ]
        }

        return out
    },
    computed: {
        // Main filtered items that match all criteria
        filteredItems() {
            // Check if packet is loaded
            if (!this.packet) {
                return [];
            }
            
            const filtered = this.items.filter(item => {
                const allowed = this.is_allowed(item);
                const hasQuantity = item.quantity > 0;
                const stateFiltered = this.filter_state(item);
                const pulledState = this.is_pulled_state(item);
                const orderTypeFiltered = this.filter_order_type(item);

                return allowed && hasQuantity && stateFiltered && pulledState && orderTypeFiltered;
            });

            return filtered;
        },

        // Only show states that are present in the currently filtered items
        filteredStates() {
            if (!this.packet || this.items.length === 0) return [];

            // Get unique states from filtered items that pass the main criteria
            const preFilteredItems = this.items.filter(item =>
                this.is_allowed(item) &&
                item.quantity > 0 &&
                this.is_pulled_state(item)
            );

            const uniqueStates = [...new Set(preFilteredItems.map(item => item.state))];

            const stateOptions = [
                { value: null, text: 'ALL STATES' }
            ];

            uniqueStates.forEach(stateValue => {
                const stateText = this.states_dict[stateValue];
                if (stateText) {
                    stateOptions.push({
                        value: stateValue,
                        text: stateText
                    });
                }
            });

            return stateOptions;
        },

        // Filter pick locations to show both main locations and sub-locations
        filteredPickLocations() {
            if (!this.packet || !this.packet.locsubs || this.filteredItems.length === 0) return [];

            // Get unique pick locsubs from current filtered items
            const uniqueLocsubs = [...new Set(this.filteredItems.map(item =>
                item.original_locsub || item.locsub
            ).filter(locsub => locsub !== null))];

            // Start with ALL option
            const locationOptions = [
                { value: null, text: 'ALL PICK LOCATIONS' }
            ];

            // Filter locsubs to only show those that exist in current filtered items
            const availableLocsubs = this.packet.locsubs.filter(locsub =>
                uniqueLocsubs.includes(locsub.value)
            );

            // Convert to display format with location names
            const displayOptions = availableLocsubs.map(locsub => ({
                value: locsub.value,
                text: this.packet.locsubsdict[locsub.value] || locsub.value
            }));

            // Sort by display text for better organization
            displayOptions.sort((a, b) => a.text.localeCompare(b.text));

            return locationOptions.concat(displayOptions);
        },

        // Filter drop locations to show both main locations and sub-locations
        filteredDropLocations() {
            if (!this.packet || !this.packet.locsubs || this.filteredItems.length === 0) return [];

            // Get unique drop locsubs from current filtered items
            const uniqueLocsubs = [...new Set(this.filteredItems.map(item =>
                item.drop_locsub
            ).filter(locsub => locsub !== null))];

            // Start with ALL option
            const locationOptions = [
                { value: null, text: 'ALL DROP LOCATIONS' }
            ];

            // Filter locsubs to only show those that exist in current filtered items
            const availableLocsubs = this.packet.locsubs.filter(locsub =>
                uniqueLocsubs.includes(locsub.value)
            );

            // Convert to display format with location names
            const displayOptions = availableLocsubs.map(locsub => ({
                value: locsub.value,
                text: this.packet.locsubsdict[locsub.value] || locsub.value
            }));

            // Sort by display text for better organization
            displayOptions.sort((a, b) => a.text.localeCompare(b.text));

            return locationOptions.concat(displayOptions);
        },

        filteredOrderTypes() {
            if (!this.packet || this.filteredItems.length === 0) return [];

            const uniqueOrderTypes = [...new Set(this.filteredItems.map(item => item.order_type))];

            const orderTypeOptions = [
                { value: null, text: 'ALL ORDER TYPES' }
            ];

            uniqueOrderTypes.forEach(orderType => {
                let displayText = '';
                switch(orderType) {
                    case 'home_delivery':
                        displayText = 'HOME DELIVERY';
                        break;
                    case 'store_pickup':
                        displayText = 'STORE PICKUP';
                        break;
                    case 'transfer_order':
                        displayText = 'STORE TRANSFER';
                        break;
                    default:
                        displayText = orderType ? orderType.toUpperCase().replace(/_/g, ' ') : 'UNKNOWN';
                }

                if (orderType) {
                    orderTypeOptions.push({
                        value: orderType,
                        text: displayText
                    });
                }
            });

            return orderTypeOptions;
        }
    },
    methods: {
        // Loading animation methods
        startApiLoading(message = 'Loading Items') {
            this.apiCallStack++;
            if (!this.apiLoading) {
                this.startLoadingAnimation(message);
            } else {
                this.loadingMessage = message;
            }
        },
        stopApiLoading() {
            this.apiCallStack--;
            if (this.apiCallStack <= 0 && this.apiLoading) {
                this.stopLoadingAnimation(true);
            }
        },
        startLoadingAnimation(message = 'Loading Items') {
            this.apiLoading = true;
            this.loadingMessage = message;
            this.loadingProgress = 0;
            this.currentTipIndex = 0;
            
            this.loadingInterval = setInterval(() => {
                if (this.loadingProgress < 90) {
                    this.loadingProgress += Math.random() * 10;
                    if (this.loadingProgress > 90) this.loadingProgress = 90;
                }
            }, 300);
            
            this.tipInterval = setInterval(() => {
                if (this.currentTipIndex < this.tips.length - 1) {
                    this.currentTipIndex++;
                }
            }, 2000);
            
            let messages = ['Loading Items', 'Fetching Data', 'Processing Records', 'Updating List', 'Finalizing'];
            let msgIndex = 0;
            this.msgInterval = setInterval(() => {
                if (msgIndex < messages.length - 1) {
                    msgIndex++;
                    this.loadingMessage = messages[msgIndex];
                }
            }, 1800);
        },
        stopLoadingAnimation(success = true) {
            if (this.loadingInterval) clearInterval(this.loadingInterval);
            if (this.tipInterval) clearInterval(this.tipInterval);
            if (this.msgInterval) clearInterval(this.msgInterval);
            
            if (success) {
                this.loadingProgress = 100;
                setTimeout(() => {
                    this.apiLoading = false;
                }, 500);
            } else {
                this.apiLoading = false;
            }
        },

        filter_order_type: function(item) {
            let status = true;
            if (this.selected_order_type) {
                if (item.order_type !== this.selected_order_type) {
                    status = false;
                }
            }
            return status;
        },
        
        is_pulled_state: function(item) {
            // Make sure 30 is included in this array
            return [0, 2,-2, 14 ,15, 3, -3, 30, -30].includes(item.state);
        },
        
        is_allowed: function(row) {
            if (!this.packet || !this.packet.userDetails) {
                return false;
            }
            
            let userrole = this.packet.userDetails.userrole;

            // For non-admin users, only show items with states that can be picked/dropped
            if (userrole !== "admin" && userrole !== "officeuser") {
                // Make sure 30 is included in allowed states for non-admin users
                if (![0, 2, -2, 14, 15, 3, -3, 30, -30].includes(row.state)) {
                    return false;
                }
            }

            let status = true;
            if (this.grn_al(row, 'pick_location_id') == false || this.grn_al(row, 'drop_location_id') == false) {
                status = false;
            }
            return status
        },
        
        filter_state: function (item) {
            let status = true;
            if (this.selected_state !== null) {
                // Convert both to numbers for consistent comparison
                const selectedState = Number(this.selected_state);
                const itemState = Number(item.state);

                if (itemState !== selectedState) {
                    status = false;
                }
            }
            return status
        },
        
        grn_al: function (row, item) {
            let out = true;

            // If item is in state 30 (DROPPED), don't apply location filters
            if (row.state === 30) {
                return true;
            }

            if (item == 'pick_location_id') {
                if (this.pick_location_id) {
                    const hasMatchingLocation =
                        (row.locsub && row.locsub == this.pick_location_id) ||
                        (row.original_locsub && row.original_locsub == this.pick_location_id) ||
                        (row.pull_location_id && row.pull_location_id == this.pick_location_id);

                    if (!hasMatchingLocation) {
                        out = false;
                    }
                }
            }

            if (item == 'drop_location_id') {
                if (this.drop_location_id) {
                    if (row.drop_locsub && row.drop_locsub != this.drop_location_id) {
                        out = false;
                    }
                    if (row.ship_locsub && row.ship_locsub != this.drop_location_id) {
                        out = false;
                    }
                }
            }

            return out;
        },
        
        get_allowed_states: function() {
            if (!this.packet || !this.packet.userDetails) {
                return mappings.states.map(function(d){ d.disabled = true; return d; });
            }
            
            let userrole = this.packet.userDetails.userrole;

            if (userrole === "admin") {
                // For admin: return ALL states
                return mappings.states.map(function(d){ 
                    d.disabled = false; 
                    return d; 
                });
            } else {
                // For non-admin users: only show these specific states
                let allowedStates = mappings.states.filter(function(d){
                    return [0, 2, -2, 14, 15, 3, -3, 30, -30].includes(d.value);
                });

                if (userrole == "warehouseuser" || userrole == "warehousemanager" || userrole == "deliverytruck" || userrole == "housetruck") {
                    return allowedStates.map(function(d){ d.disabled = false; return d; });
                }
                else {
                    return allowedStates.map(function(d){ d.disabled = true; return d; });
                }
            }
        },
        
        check_states: function(item) {
            if (!this.packet || !this.packet.userDetails) {
                return [{ value: item.state, text: 'Loading...', disabled: true }];
            }
            
            let userrole = this.packet.userDetails.userrole;
            let that = this;

            // If pickup truck is ali, show only current state with special message
            if (this.is_ali_truck(item)) {
                return [{ value: item.state, text: 'ASSIGN TRUCK FIRST', disabled: true }];
            }

            // Get ALL states from mappings to show everything
            const allStates = mappings.states.map(state => ({
                value: state.value,
                text: state.text,
                // Start with all disabled, enable based on logic below
                disabled: true
            }));

            // Determine selectable states based on your existing business logic
            const getSelectableStates = () => {
                // For admin users, they can select everything
                if (userrole === "admin") {
                    return allStates.map(state => state.value);
                }
                
                // Base selectable states for non-admin users
                let selectable = [];
                
                // Your existing logic from the original function
                if ([3, -3, 15 ,30, -30].includes(item.state)) {
                    // From PICKED/CANT PICKED/DROPPED states
                    selectable = [0, 2, -2, 14 , 15, 3, -3, 30, -30];
                }
                else if (item.state === 2) {
                    // From PULLED state
                    selectable = [2, 14, 15,3, -3, 30, -30];
                }
                else if (item.state === -2) {
                    // From CANT PULLED state
                    selectable = [-2, 14, 15, 3, -3, 30, -30];
                }
                else if (item.state === 14) {
                    // From SHIPPED TO WAREHOUSE state
                    selectable = [14, 15, 3, -3, 30, -30];
                }
                else if (item.state === 15) {
                    // From SHIPPED TO WAREHOUSE state
                    selectable = [14, 14, 3, -3, 30, -30];
                }
                else if (item.state === 0) {
                    // From ORDERED state - check for locationadmin
                    if (userrole == "locationadmin" && item.pull_location_id == that.packet.userDetails.properties.location_id) {
                        selectable = [0, 2, -2, 14, 15, 3, -3, 30, -30];
                    } else {
                        selectable = [0, 2, -2, 14, 15, 3, -3, 30, -30];
                    }
                }
                else {
                    // For any other state, only current state is selectable
                    selectable = [item.state];
                }
                
                return selectable;
            };

            const selectableStates = getSelectableStates();
            
            // Return all states with proper enabling
            return allStates.map(state => {
                const isSelectable = selectableStates.includes(state.value);
                const isCurrentState = state.value === item.state;
                
                // Current state should always be enabled so it shows in dropdown
                if (isCurrentState) {
                    return {
                        ...state,
                        disabled: false,
                        text: state.text
                    };
                }
                
                return {
                    ...state,
                    disabled: !isSelectable,
                    text: isSelectable ? state.text : `${state.text}`
                };
            });
        },
        
        should_disable_dropdown: function(item) {
            if (!this.packet || !this.packet.userDetails || !this.packet.locsubsdict) {
                return true;
            }
            
            let userrole = this.packet.userDetails.userrole;
            let isAdmin = userrole === "admin";
            
            // For admin users: only disable if out of stock or state is 30
            if (isAdmin) {
                return this.packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK'  
                || this.is_ali_truck(item);
            }
            // For non-admin users: disable for all conditions
            else {
                return this.packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK' ||
                       item.state == 30 || item.state == 0
                       || this.is_ali_truck(item);
            }
        },
        
        is_ali_truck: function(item) {
            // Only disabled if pickup_truck is null/undefined
            return !item.pickup_truck;
        },
        
        get_tooltip_message: function(item) {
            if (this.is_ali_truck(item)) {
                return 'Item needs to be assigned a truck';
            }
            return '';
        },
        
        get_background: function(item) {
            let state = item.state;
            let bg = 'white'

            if (this.is_ali_truck(item)) {
                bg = 'lightcoral'; // Red background for items with ali truck
            }
            else if (state == 0 || state == 2 || state == -2) {
                bg = 'lightyellow';  // ORDERED, PULLED, CANT PULL - white background
            }
            else if (state == 3) {
                bg = 'lightgreen'  // PICKED - green background
            }
            else if (state == -3) {
                bg = 'red'  // CANT PICKED - yellow background
            }
            else if (state == 30) {
                bg = 'lightblue'  // DROPPED - blue background
            }
            else {
                bg = 'lightgray'  // Other states - gray background
            }
            return bg
        },
        
        allowed: function (item) {
            let is_main_warehouse = item.is_main_warehouse;
            let userrole = this.packet.userDetails.userrole;
            let status = true;
            if (this.pick_location_id == null) {
                status = true;
            }
            else {
                if (this.pick_location_id == item.pull_location_id) {
                    status = true
                }
                else {
                    status = false;
                }
            }
            return status
        },
        
        toggle_details: function (item) {
            item.show_details = (!item.show_details)
        },
        
        show_comments: function (item) {
            this.item_comments_invoice_id = item.invoice_id;
            this.item_comments_itemid = item.itemid;

            this.$bvModal.show("modal-itp-comments");
        },
        
        update_invoice_item_state: function (item) {
            if (!this.packet || !this.packet.userDetails) {
                this.$bvToast.toast(
                    "User data not loaded yet.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                return;
            }
            
            let path = "/api/sales/update_invoice_item_state/"
            let that = this;

            // Store the original state in case we need to revert
            const originalState = item.state;

            // Debug: Log what we have in the item
            console.log("Item data for update:", {
                invoice_id: item.invoice_id,
                order_type: item.order_type,
                incoming_type: item.incoming_type,
                state: item.state,
                product_sku: item.product_sku
            });

            // Get location information from the item
            let pick_location = item.original_locsub || item.locsub;
            let ship_location = item.ship_locsub || item.drop_locsub;

            // Determine the incoming type - check multiple possible sources
            let incomingType = '';
            
            // First, check if there's an explicit incoming_type
            if (item.incoming_type) {
                incomingType = item.incoming_type.toUpperCase();
            } 
            // If not, try to determine from order_type
            else if (item.order_type) {
                let orderType = item.order_type.toUpperCase();
                if (orderType.includes('TRANSFER')) {
                    incomingType = 'STORE_TRANSFER_ORDER';
                } else if (orderType.includes('DAMAGE')) {
                    incomingType = 'DAMAGE_ORDER';
                } else if (orderType.includes('HOME_DELIVERY') || orderType.includes('STORE_PICKUP')) {
                    incomingType = 'REGULAR_ORDER';
                }
            }
            
            // If still not determined, check invoice_id pattern
            if (!incomingType && item.invoice_id) {
                if (item.invoice_id.toString().includes('TRANSFER') || 
                    item.invoice_id.toString().includes('TO')) {
                    incomingType = 'STORE_TRANSFER_ORDER';
                } else if (item.invoice_id.toString().includes('DAMAGE') || 
                        item.invoice_id.toString().includes('DO')) {
                    incomingType = 'DAMAGE_ORDER';
                }
            }

            // If still empty, set a default
            if (!incomingType) {
                incomingType = 'REGULAR_ORDER';
            }

            let data = {
                invoice_id: item.invoice_id,
                itemid: item.itemid,
                state: item.state,
                changed_by: this.packet.userDetails.username,
                product_sku: item.product_sku,
                quantity: item.quantity,
                // Add location data to payload
                pick_location: pick_location,
                ship_location: ship_location,
                drop_location: item.drop_locsub,
                original_locsub: item.original_locsub,
                ship_locsub: item.ship_locsub,
                incoming_type: incomingType, // CRITICAL: This must be sent
                // Add truck information if available
                pickup_truck: item.pickup_truck
            }

            console.log("Sending update data to backend:", data);

            let s = function (response) {
                console.log("Backend response:", response.data);
                
                if (response.data.error) {
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                    // Revert to original state in UI
                    item.state = originalState;
                    that.$forceUpdate();
                }
                else {
                    that.$bvToast.toast(
                        "Success updating item state.",
                        { title: "Success", autoHideDelay: 1500, variant: "success" }
                    );
                    // Optionally refresh the data to get any server-side updates
                    setTimeout(() => {
                        that.search_dates();
                    }, 500);
                }
            }

            let f = function (error) {
                console.log("Request error:", error);
                that.$bvToast.toast(
                    "Error updating item state.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                // Revert to original state in UI
                item.state = originalState;
                that.$forceUpdate();
            }

            Requestor.postAsync(path, data, s, f);
        },
        
        search_dates: function(e) {
            if (e) {
                e.preventDefault();
            }

            if (!this.query.startDate || !this.query.endDate) {
                this.$bvToast.toast(
                    "Please select a date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                return;
            }

            this.get_pick_items_for_date_range();
        },
        
        get_pick_items_for_date_range: function () {
            let path = "/api/sales/get_pick_items_for_date_range/"
            let that = this;
            this.startApiLoading('Fetching Items');
            
            let data = { 
                startDate: this.query.startDate, 
                endDate: this.query.endDate, 
                merchandise_status: [1] 
            };

            // Only include location_id for non-admin/officeuser/housetruck roles
            if (this.packet && this.packet.userDetails) {
                let userrole = this.packet.userDetails.userrole;
                if (userrole !== 'admin' && userrole !== 'officeuser' && userrole !== 'housetruck') {
                    if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                        data.location_id = this.packet.userDetails.properties.location_id;
                    }
                }
            }

            let s = function (response) {
                if (response.data.result) {
                    that.items = response.data.result;
                }
                else {
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
                that.items_being_loaded = false;
                that.stopApiLoading();
            }

            let f = function (error) {
                console.log(error)
                that.$bvToast.toast(
                    "Error loading items for the date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.items_being_loaded = false;
                that.stopApiLoading();
            }

            this.items = [];
            this.items_being_loaded = true;
            this.selected_state = null;
            this.pick_location_id = null;
            this.drop_location_id = null;
            this.selected_order_type = null;
            Requestor.postAsync(path, data, s, f);
        },
        
        update_colors_dict: function () {
            for (var i = 0; i < this.items.length; i++) {
                let invoice_id = this.items[i].invoice_id;
                for (var j = 0; j < this.items[i].items.length; j++) {
                    let itemid = this.items[i].items[j].itemid;
                    let state = this.items[i].items[j].state;

                    let color = 'white';
                    if (state == 2) {
                        color = '#c5e1a5'
                    }
                    if (state == -2) {
                        color = '#b0bec5'
                    }

                    let key = invoice_id + itemid;
                    this.colors_dict[key] = color;
                }
            }
        },
        
        fetch_prereqs: function () {
        },
        
        fetch: function () {
            this.items = []
            this.dates = []
            this.active_date = null;
            this.locsub = null;
        },
        
        sortby: function (key, mapper) {
            if (this.sort_asc) {
                this.items = Requestor.sort(this.items, key, mapper)
            }
            else {
                this.items = Requestor.sort_reverse(this.items, key, mapper)
            }
            this.sort_asc = !this.sort_asc;
        },
        
        isMobile: function () {
            if (
                (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
                ||
                screen.width <= 760
            ) {
                return true
            } else {
                return false
            }
        },
        
        filter_locations: function (locations) {
            if (!this.packet || !this.packet.userDetails) {
                return locations || [];
            }

            let userrole = this.packet.userDetails.userrole;

            // For housetruck (and similar roles), location_id might not exist in properties
            let userLocationId = undefined;

            // Only try to get location_id for roles that should have it
            if (userrole !== 'admin' && userrole !== 'officeuser' && userrole !== 'housetruck') {
                if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    userLocationId = this.packet.userDetails.properties.location_id;
                }
            }

            if (userrole == 'admin' || userrole == 'officeuser' || userrole == 'housetruck') {
                return locations ? locations.filter(d => d && ![44, 46].includes(d.value)) : [];
            }
            else {
                // For non-admin users, filter locations to show only their assigned location
                if (userLocationId) {
                    return locations ? locations.filter(function (d) {
                        return d && d.value == userLocationId;
                    }) : [];
                } else {
                    // If no location is assigned, show main warehouse only
                    return locations ? locations.filter(function (d) {
                        return d && (d.is_main_warehouse === true || d.is_main_warehouse === 1);
                    }) : [];
                }
            }
        },
        
        initDatePicker: function() {
            // Wait for next tick to ensure DOM is ready
            this.$nextTick(() => {
                try {
                    const Lightpick = require('lightpick');
                    let that = this;
                    
                    var picker = new Lightpick({
                        field: document.getElementById('dates'),
                        singleDate: false,
                        repick: true,
                        format: 'YYYY-MM-DD',
                        onSelect: function(start, end) {
                            that.query.startDate = start ? start.format('YYYY-MM-DD') : '';
                            that.query.endDate = end ? end.format('YYYY-MM-DD') : '';
                            if (start && end) {
                                that.search_dates();
                            }
                        }
                    });
                    
                    // Set default date to today
                    picker.setDate(moment().toDate());
                } catch (error) {
                    console.error('Error initializing date picker:', error);
                }
            });
        },
    },
    
    mounted: function() {
        this.initDatePicker();
        // Load data for today by default
        this.search_dates();
    },
    
    created: function() {
        try {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.locsubs = this.packet.locsubs || [];
            this.original_locsubs = this.packet.original_locsubs || [];

            // Only filter locsubs for roles that should have location_id
            let userrole = this.packet.userDetails.userrole;
            if (userrole !== 'admin' && userrole !== 'officeuser' && userrole !== 'housetruck') {
                if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    let location_id = this.packet.userDetails.properties.location_id;
                    this.locsubs = this.locsubs.filter(function(d) {
                        return d.location_id == location_id;
                    });
                }
            }

            // Initialize states now that packet is loaded
            this.states = this.get_allowed_states();
        } catch (error) {
            console.error('Error initializing component:', error);
            this.packet = { userDetails: {}, locsubs: [], locsubsdict: {}, trucksdict: {} };
            this.locsubs = [];
            this.original_locsubs = [];
            this.states = mappings.states.map(function(d){ d.disabled = true; return d; });
        }
    }
}
</script>

<style scoped>
    /* Glass Theme Container */
    .items-to-pull.glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
        padding: 24px;
    }

    /* Same background image as Delivery Operations */
    .items-to-pull.glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Glass Card Effect */
    .glass-alert,
    .glass-table-card,
    .glass-empty-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    /* Glass Inputs */
    .glass-input {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }

    .glass-input:focus {
        border-color: #4299e1 !important;
        box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;
    }

    .glass-select {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }

    .glass-select:hover {
        background: rgba(255, 255, 255, 0.95) !important;
        border-color: rgba(0, 0, 0, 0.2) !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, #4a5568, #2d3748) !important;
        border: none !important;
        color: white !important;
        transition: all 0.3s ease !important;
        border-radius: 12px !important;
    }

    .glass-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }

    /* Glass Comment Button */
    .glass-comment-btn {
        background: rgba(0, 123, 255, 0.1);
        border: 1px solid rgba(0, 123, 255, 0.3);
        color: #007bff;
        padding: 5px 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .glass-comment-btn:hover {
        background: rgba(0, 123, 255, 0.2);
        transform: scale(1.05);
    }

    /* Glass Table */
    .glass-table {
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
    }

    .glass-table-header {
        background: rgba(60, 60, 60, 0.9) !important;
        backdrop-filter: blur(5px);
        padding: 3px !important;
    }

    .glass-table-row {
        transition: all 0.3s ease;
    }

    .glass-table-row:hover {
        background: rgba(255, 255, 255, 0.7) !important;
        transform: scale(1.01);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    /* Glass Status Select */
    .glass-status-select {
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }

    .glass-status-select:hover {
        transform: scale(1.02);
    }

    /* Filter Label */
    .filter-label {
        font-weight: bold;
        font-size: 11px;
        margin-bottom: 4px;
        color: #4a5568;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    /* Existing styles */
    select option:disabled {
        color: #888 !important;
        font-style: italic;
        background-color: #f5f5f5 !important;
    }

    select option {
        padding: 8px 12px !important;
        font-size: 13px !important;
    }

    select option:not(:disabled) {
        font-weight: 600;
        background-color: white !important;
    }

    select option[disabled] {
        border-bottom: 1px solid #e0e0e0;
    }

    select option:not(:disabled):hover {
        background-color: #e8f5e9 !important;
    }

    select[size="sm"] {
        min-width: 180px !important;
    }

    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
        padding: 0px;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

    table {
        table-layout: fixed;
        width: 100%;
    }

    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }

    /* ========== Loading Overlay Styles ========== */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 32px;
    }

    .loading-ring {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 4px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 32px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 40px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 24px;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.3rem;
        margin-bottom: 8px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 6px;
        height: 6px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-8px); }
    }

    .loading-progress {
        width: 100%;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 20px;
    }

    .tip-text {
        color: #718096;
        font-size: 0.9rem;
        animation: tipFade 0.5s ease;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Responsive design */
    @media (max-width: 768px) {
        .items-to-pull.glass-theme {
            padding: 16px;
        }
        
        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
        
        .responsive-input {
            width: 100% !important;
            display: block !important;
        }
        
        .loading-card {
            padding: 32px 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/ItemsToPick.vue